/* tslint:disable */
/* eslint-disable */
/* @relayHash 0c9e9ceb422308d6b747714fce42a81a */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type headerRootQueryVariables = {
    hasUserId: boolean;
    hasTradeUserId: boolean;
    previewKey?: string | null;
    userId: string;
    userIds: Array<string | null>;
    isClient: boolean;
    fetchRegionalInfo: boolean;
    fetchTradeNav: boolean;
    fetchNav: boolean;
    zipCode: string;
    userCountryCode?: string | null;
    hasSessionCountryCode: boolean;
    localRecentHistoryItemIds?: Array<string | null> | null;
    fetchUserRecentHistoryItem?: boolean | null;
    checkoutUserId: string;
    hasCheckoutUserId: boolean;
};
export type headerRootQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": FragmentRefs<"Header_viewer">;
    };
};
export type headerRootQuery = {
    readonly response: headerRootQueryResponse;
    readonly variables: headerRootQueryVariables;
};



const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "checkoutUserId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fetchNav"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fetchRegionalInfo"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fetchTradeNav"
},
v4 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "fetchUserRecentHistoryItem"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hasCheckoutUserId"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hasSessionCountryCode"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hasTradeUserId"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hasUserId"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isClient"
},
v10 = {
  "defaultValue": ([]/*: any*/),
  "kind": "LocalArgument",
  "name": "localRecentHistoryItemIds"
},
v11 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "previewKey"
},
v12 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "userCountryCode"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userId"
},
v14 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userIds"
},
v15 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "zipCode"
},
v16 = {
  "alias": "isAutomatedOfferNotificationDisabled",
  "args": [
    {
      "kind": "Literal",
      "name": "key",
      "value": "disableAutomatedOfferBellNotification"
    }
  ],
  "kind": "ScalarField",
  "name": "isEnabled",
  "storageKey": "isEnabled(key:\"disableAutomatedOfferBellNotification\")"
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v18 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": "showUnreadOnly"
  }
],
v19 = {
  "kind": "Variable",
  "name": "userIds",
  "variableName": "userIds"
},
v20 = {
  "kind": "Literal",
  "name": "first",
  "value": 3
},
v21 = {
  "kind": "Variable",
  "name": "userId",
  "variableName": "userId"
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isVip",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isVerifiedTrade",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currency",
  "storageKey": null
},
v25 = [
  {
    "kind": "Variable",
    "name": "excludeItemPks",
    "variableName": "localRecentHistoryItemIds"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 12
  }
],
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v28 = [
  (v27/*: any*/),
  (v17/*: any*/)
],
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profileStatus",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "concreteType": "TradeFirmRewards",
  "kind": "LinkedField",
  "name": "rewards",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ParentProgram",
      "kind": "LinkedField",
      "name": "currentProgram",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "LoyaltyProgram",
          "kind": "LinkedField",
          "name": "programInfo",
          "plural": false,
          "selections": [
            (v32/*: any*/),
            (v17/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "buyerDisplayable",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "concreteType": "UserPreferences",
  "kind": "LinkedField",
  "name": "preferences",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "shareActivities",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "concreteType": "Summary",
  "kind": "LinkedField",
  "name": "conversationSummary",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "unread",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v38 = {
  "kind": "InlineFragment",
  "selections": [
    (v17/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v40 = [
  (v24/*: any*/),
  (v39/*: any*/)
],
v41 = [
  {
    "kind": "Literal",
    "name": "elementTypes",
    "value": [
      "PENDING_FEEDBACK",
      "TRADE_REWARD",
      "TRADE_REWARD_PRORATED",
      "TRADE_REWARD_PROGRAM",
      "AUTOMATED_OFFER"
    ]
  },
  (v20/*: any*/)
],
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "eventDate",
  "storageKey": null
},
v44 = {
  "alias": "thumbnail",
  "args": [
    {
      "kind": "Literal",
      "name": "size",
      "value": "thumb"
    }
  ],
  "kind": "ScalarField",
  "name": "firstPhotoWebPath",
  "storageKey": "firstPhotoWebPath(size:\"thumb\")"
},
v45 = {
  "kind": "Variable",
  "name": "rootId",
  "variableName": "previewKey"
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v47 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "path",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isLinkable",
    "storageKey": null
  }
],
v48 = {
  "alias": null,
  "args": null,
  "concreteType": "LinkData",
  "kind": "LinkedField",
  "name": "linkData",
  "plural": false,
  "selections": (v47/*: any*/),
  "storageKey": null
},
v49 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "NavigationModule",
    "kind": "LinkedField",
    "name": "modules",
    "plural": true,
    "selections": [
      (v46/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "NavigationTopLevel",
        "kind": "LinkedField",
        "name": "items",
        "plural": true,
        "selections": [
          (v46/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "column",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "NavigationItem",
            "kind": "LinkedField",
            "name": "items",
            "plural": true,
            "selections": [
              (v46/*: any*/),
              (v48/*: any*/),
              (v17/*: any*/)
            ],
            "storageKey": null
          },
          (v17/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "imageUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "LinkData",
        "kind": "LinkedField",
        "name": "imageLinkData",
        "plural": false,
        "selections": (v47/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "imageTitlePrimary",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "imageTitleSecondary",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "imageHeight",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "imageWidth",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "imageLink",
        "storageKey": null
      },
      (v48/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isHighlighted",
        "storageKey": null
      },
      (v27/*: any*/),
      (v17/*: any*/)
    ],
    "storageKey": null
  },
  (v17/*: any*/)
],
v50 = {
  "kind": "Variable",
  "name": "zipCode",
  "variableName": "zipCode"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "headerRootQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "Header_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v8/*: any*/),
      (v7/*: any*/),
      (v11/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v9/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/),
      (v15/*: any*/),
      (v12/*: any*/),
      (v6/*: any*/),
      (v10/*: any*/),
      (v4/*: any*/),
      (v0/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Operation",
    "name": "headerRootQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": "isNotificationsEnabled",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "NOTIFICATIONS"
              }
            ],
            "kind": "ScalarField",
            "name": "isEnabledByLocale",
            "storageKey": "isEnabledByLocale(featureName:\"NOTIFICATIONS\")"
          },
          {
            "alias": "isFavoritesEnabled",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "FAVORITES"
              }
            ],
            "kind": "ScalarField",
            "name": "isEnabledByLocale",
            "storageKey": "isEnabledByLocale(featureName:\"FAVORITES\")"
          },
          {
            "alias": "isCartEnabled",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "CART"
              }
            ],
            "kind": "ScalarField",
            "name": "isEnabledByLocale",
            "storageKey": "isEnabledByLocale(featureName:\"CART\")"
          },
          (v16/*: any*/),
          {
            "alias": "isSuggestionsFeatureEnabled",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "SEARCH_BAR_SUGGESTIONS"
              }
            ],
            "kind": "ScalarField",
            "name": "isEnabledByLocale",
            "storageKey": "isEnabledByLocale(featureName:\"SEARCH_BAR_SUGGESTIONS\")"
          },
          (v17/*: any*/),
          {
            "condition": "isClient",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "relayIsClient",
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              {
                "if": null,
                "kind": "Defer",
                "label": "AccountNav_viewer$defer$AccountNavContent_viewer",
                "selections": [
                  {
                    "alias": "isMessageCenterEnabled",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "featureName",
                        "value": "MESSAGE_CENTER"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "isEnabledByLocale",
                    "storageKey": "isEnabledByLocale(featureName:\"MESSAGE_CENTER\")"
                  }
                ]
              },
              {
                "if": null,
                "kind": "Defer",
                "label": "Notifications_viewer$defer$ActivityFeed_viewer",
                "selections": [
                  {
                    "alias": "promoCodeMessaging",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "feature",
                        "value": "promoCodeMessaging"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "featureFlag",
                    "storageKey": "featureFlag(feature:\"promoCodeMessaging\")"
                  },
                  (v16/*: any*/)
                ]
              },
              {
                "if": null,
                "kind": "Defer",
                "label": "Notifications_initialViewer$defer$Conversations_viewer",
                "selections": [
                  {
                    "condition": "hasUserId",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": (v18/*: any*/),
                        "concreteType": "ConversationConnection",
                        "kind": "LinkedField",
                        "name": "conversations",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ConversationMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "totalUnreadConversationCount",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "conversations(filter:\"showUnreadOnly\")"
                      }
                    ]
                  }
                ]
              },
              {
                "if": null,
                "kind": "Defer",
                "label": "Notifications_initialViewer$defer$NotificationsIcon_viewer",
                "selections": [
                  (v16/*: any*/),
                  {
                    "condition": "hasUserId",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": (v18/*: any*/),
                        "concreteType": "ConversationConnection",
                        "kind": "LinkedField",
                        "name": "conversations",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ConversationMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "lastUnreadMessageDate",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "conversations(filter:\"showUnreadOnly\")"
                      }
                    ]
                  }
                ]
              },
              {
                "if": null,
                "kind": "Defer",
                "label": "Header_viewer$defer$userTracking_viewer",
                "selections": [
                  {
                    "condition": "hasCheckoutUserId",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Variable",
                            "name": "buyerId",
                            "variableName": "checkoutUserId"
                          }
                        ],
                        "concreteType": "TransactionsCounter",
                        "kind": "LinkedField",
                        "name": "transactionsCounter",
                        "plural": false,
                        "selections": [
                          {
                            "alias": "guestCheckoutTransactions",
                            "args": null,
                            "kind": "ScalarField",
                            "name": "guest",
                            "storageKey": null
                          },
                          {
                            "condition": "hasUserId",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "alias": "submittedTransactions",
                                "args": null,
                                "kind": "ScalarField",
                                "name": "submitted",
                                "storageKey": null
                              },
                              {
                                "alias": "confirmedTransactions",
                                "args": null,
                                "kind": "ScalarField",
                                "name": "confirmed",
                                "storageKey": null
                              }
                            ]
                          }
                        ],
                        "storageKey": null
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "condition": "hasUserId",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1
                  },
                  {
                    "kind": "Literal",
                    "name": "portfolioTypes",
                    "value": [
                      "CART"
                    ]
                  },
                  (v19/*: any*/)
                ],
                "concreteType": "PortfoliosConnection",
                "kind": "LinkedField",
                "name": "portfolios",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PortfoliosEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PortfolioV2",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": [
                              (v20/*: any*/)
                            ],
                            "concreteType": "PortfolioItemsConnection",
                            "kind": "LinkedField",
                            "name": "items",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "totalResults",
                                "storageKey": null
                              }
                            ],
                            "storageKey": "items(first:3)"
                          },
                          (v17/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  (v21/*: any*/)
                ],
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v17/*: any*/),
                  (v22/*: any*/),
                  (v23/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Profile",
                    "kind": "LinkedField",
                    "name": "profile",
                    "plural": false,
                    "selections": [
                      (v24/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "if": null,
                    "kind": "Defer",
                    "label": "SearchBar_viewer$defer$getRecentHistory_user",
                    "selections": [
                      {
                        "condition": "fetchUserRecentHistoryItem",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": (v25/*: any*/),
                            "concreteType": "RecentHistoryItemsConnection",
                            "kind": "LinkedField",
                            "name": "recentHistoryItems",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "RecentHistoryItemsEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Item",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "contemporaryTrackingString",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": [
                                          {
                                            "kind": "Literal",
                                            "name": "size",
                                            "value": "small"
                                          }
                                        ],
                                        "kind": "ScalarField",
                                        "name": "firstPhotoWebPath",
                                        "storageKey": "firstPhotoWebPath(size:\"small\")"
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "pdpURL",
                                        "storageKey": null
                                      },
                                      (v26/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "browseUrl",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "categoryCode",
                                        "storageKey": null
                                      },
                                      (v27/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "categoryPath",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Seller",
                                        "kind": "LinkedField",
                                        "name": "seller",
                                        "plural": false,
                                        "selections": (v28/*: any*/),
                                        "storageKey": null
                                      },
                                      (v17/*: any*/),
                                      (v29/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "cursor",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "PageInfo",
                                "kind": "LinkedField",
                                "name": "pageInfo",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "endCursor",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "hasNextPage",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": (v25/*: any*/),
                            "filters": [
                              "excludeItemPks"
                            ],
                            "handle": "connection",
                            "key": "getRecentHistory_recentHistoryItems",
                            "kind": "LinkedHandle",
                            "name": "recentHistoryItems"
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "if": null,
                    "kind": "Defer",
                    "label": "Header_viewer$defer$userTracking_user",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "createdDate",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "firstSessionDate",
                        "storageKey": null
                      },
                      (v22/*: any*/),
                      (v23/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "verifiedTradeStatus",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UserExistsMetadataType",
                        "kind": "LinkedField",
                        "name": "authMetadata",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "emailOnly",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hasPassword",
                            "storageKey": null
                          },
                          (v17/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Profile",
                        "kind": "LinkedField",
                        "name": "profile",
                        "plural": false,
                        "selections": [
                          (v30/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "zipCode",
                            "storageKey": null
                          },
                          (v24/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v27/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "totalMessagesToDealers",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TradeFirmType",
                        "kind": "LinkedField",
                        "name": "tradeFirm",
                        "plural": false,
                        "selections": [
                          (v27/*: any*/),
                          (v31/*: any*/),
                          (v33/*: any*/),
                          (v17/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "mentionMeTagParameters",
                        "kind": "LinkedField",
                        "name": "mentionMeTagParameters",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "ciphertext",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "nonce",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Promotion",
                        "kind": "LinkedField",
                        "name": "activePromotion",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "campaignName",
                            "storageKey": null
                          },
                          (v34/*: any*/),
                          (v17/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "condition": "isClient",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      (v35/*: any*/),
                      {
                        "condition": "hasTradeUserId",
                        "kind": "Condition",
                        "passingValue": false,
                        "selections": [
                          {
                            "if": null,
                            "kind": "Defer",
                            "label": "AccountNav_user$defer$AccountNavContent_user",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Profile",
                                "kind": "LinkedField",
                                "name": "profile",
                                "plural": false,
                                "selections": [
                                  (v30/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v36/*: any*/)
                            ]
                          }
                        ]
                      },
                      {
                        "if": null,
                        "kind": "Defer",
                        "label": "AccountNav_user$defer$AccountNavTrigger_user",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Profile",
                            "kind": "LinkedField",
                            "name": "profile",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "firstName",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v23/*: any*/),
                          {
                            "condition": "hasTradeUserId",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TradeFirmRewards",
                                "kind": "LinkedField",
                                "name": "tradeFirmRewards",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "currentYearPoints",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ParentProgram",
                                    "kind": "LinkedField",
                                    "name": "currentProgram",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "LoyaltyProgram",
                                        "kind": "LinkedField",
                                        "name": "programInfo",
                                        "plural": false,
                                        "selections": [
                                          (v37/*: any*/),
                                          (v17/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "condition": "hasTradeUserId",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "if": null,
                            "kind": "Defer",
                            "label": "AccountNav_user$defer$TradeAccountNavContent_user",
                            "selections": [
                              (v27/*: any*/),
                              (v23/*: any*/),
                              (v36/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TradeFirmType",
                                "kind": "LinkedField",
                                "name": "tradeFirm",
                                "plural": false,
                                "selections": [
                                  (v27/*: any*/),
                                  (v31/*: any*/),
                                  (v33/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "TradeFirmPublicProfileType",
                                    "kind": "LinkedField",
                                    "name": "publicProfile",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "urlLabel",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "TradeFirmMemberType",
                                    "kind": "LinkedField",
                                    "name": "members",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "userId",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "publicProfileManager",
                                        "storageKey": null
                                      },
                                      (v17/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v17/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "condition": "isClient",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "if": null,
                            "kind": "Defer",
                            "label": "Notifications_user$defer$ShareActivityAlert_user",
                            "selections": [
                              (v27/*: any*/),
                              (v35/*: any*/)
                            ]
                          },
                          {
                            "if": null,
                            "kind": "Defer",
                            "label": "Notifications_user$defer$ActivityFeed_user",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Promotion",
                                "kind": "LinkedField",
                                "name": "activePromotion",
                                "plural": false,
                                "selections": [
                                  (v34/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "PromotionMeta",
                                    "kind": "LinkedField",
                                    "name": "promotionMeta",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "displayMessage",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "displayCta",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "adjustmentRateList",
                                    "plural": true,
                                    "selections": [
                                      (v29/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "reference",
                                        "storageKey": null
                                      },
                                      (v38/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v32/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "FlatAdjustmentRate",
                                    "kind": "LinkedField",
                                    "name": "flatAdjustmentRate",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "FinancialAmount",
                                        "kind": "LinkedField",
                                        "name": "rate",
                                        "plural": false,
                                        "selections": (v40/*: any*/),
                                        "storageKey": null
                                      },
                                      (v17/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "PercentAdjustmentRate",
                                    "kind": "LinkedField",
                                    "name": "percentAdjustmentRate",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "rate",
                                        "storageKey": null
                                      },
                                      (v17/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v17/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": (v41/*: any*/),
                                "concreteType": "ActivityFeedConnection",
                                "kind": "LinkedField",
                                "name": "activityFeed",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ActivityFeedEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ActivityFeedElement",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v42/*: any*/),
                                          (v43/*: any*/),
                                          (v27/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "apiType",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "status",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Anchor",
                                            "kind": "LinkedField",
                                            "name": "anchors",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "sourceType",
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": null,
                                                "kind": "LinkedField",
                                                "name": "source",
                                                "plural": false,
                                                "selections": [
                                                  (v29/*: any*/),
                                                  {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                      (v27/*: any*/),
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "FinancialAmount",
                                                        "kind": "LinkedField",
                                                        "name": "rewardEarned",
                                                        "plural": false,
                                                        "selections": (v40/*: any*/),
                                                        "storageKey": null
                                                      }
                                                    ],
                                                    "type": "TradeFirmReward",
                                                    "abstractKey": null
                                                  },
                                                  {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "LoyaltyProgram",
                                                        "kind": "LinkedField",
                                                        "name": "programInfo",
                                                        "plural": false,
                                                        "selections": [
                                                          (v37/*: any*/),
                                                          (v32/*: any*/),
                                                          (v17/*: any*/)
                                                        ],
                                                        "storageKey": null
                                                      }
                                                    ],
                                                    "type": "ParentProgram",
                                                    "abstractKey": null
                                                  },
                                                  {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "token",
                                                        "storageKey": null
                                                      },
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "Transaction",
                                                        "kind": "LinkedField",
                                                        "name": "transaction",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "Item",
                                                            "kind": "LinkedField",
                                                            "name": "item",
                                                            "plural": false,
                                                            "selections": [
                                                              (v26/*: any*/),
                                                              (v44/*: any*/),
                                                              (v17/*: any*/)
                                                            ],
                                                            "storageKey": null
                                                          },
                                                          (v17/*: any*/)
                                                        ],
                                                        "storageKey": null
                                                      }
                                                    ],
                                                    "type": "OrderFeedback",
                                                    "abstractKey": null
                                                  },
                                                  {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                      (v27/*: any*/),
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "TransactionSummaryObject",
                                                        "kind": "LinkedField",
                                                        "name": "summary",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "offerDiscountPercentage",
                                                            "storageKey": null
                                                          }
                                                        ],
                                                        "storageKey": null
                                                      },
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "Item",
                                                        "kind": "LinkedField",
                                                        "name": "item",
                                                        "plural": false,
                                                        "selections": [
                                                          (v26/*: any*/),
                                                          (v44/*: any*/),
                                                          {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "ItemPricing",
                                                            "kind": "LinkedField",
                                                            "name": "pricing",
                                                            "plural": false,
                                                            "selections": [
                                                              {
                                                                "alias": null,
                                                                "args": null,
                                                                "concreteType": "FinancialAmount",
                                                                "kind": "LinkedField",
                                                                "name": "retailPrice",
                                                                "plural": false,
                                                                "selections": [
                                                                  {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "ConvertedAmountList",
                                                                    "kind": "LinkedField",
                                                                    "name": "convertedAmountList",
                                                                    "plural": true,
                                                                    "selections": [
                                                                      (v39/*: any*/),
                                                                      (v24/*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                  }
                                                                ],
                                                                "storageKey": null
                                                              }
                                                            ],
                                                            "storageKey": null
                                                          },
                                                          (v17/*: any*/)
                                                        ],
                                                        "storageKey": null
                                                      },
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "Offer",
                                                        "kind": "LinkedField",
                                                        "name": "mostRecentOffer",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "FinancialAmount",
                                                            "kind": "LinkedField",
                                                            "name": "amountPerItem",
                                                            "plural": false,
                                                            "selections": [
                                                              {
                                                                "alias": null,
                                                                "args": null,
                                                                "concreteType": "ConvertedAmountList",
                                                                "kind": "LinkedField",
                                                                "name": "convertedAmountList",
                                                                "plural": true,
                                                                "selections": (v40/*: any*/),
                                                                "storageKey": null
                                                              }
                                                            ],
                                                            "storageKey": null
                                                          },
                                                          (v17/*: any*/)
                                                        ],
                                                        "storageKey": null
                                                      },
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "Conversation",
                                                        "kind": "LinkedField",
                                                        "name": "conversation",
                                                        "plural": false,
                                                        "selections": (v28/*: any*/),
                                                        "storageKey": null
                                                      }
                                                    ],
                                                    "type": "Transaction",
                                                    "abstractKey": null
                                                  },
                                                  (v38/*: any*/)
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          },
                                          (v17/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": "activityFeed(elementTypes:[\"PENDING_FEEDBACK\",\"TRADE_REWARD\",\"TRADE_REWARD_PRORATED\",\"TRADE_REWARD_PROGRAM\",\"AUTOMATED_OFFER\"],first:3)"
                              }
                            ]
                          },
                          {
                            "if": null,
                            "kind": "Defer",
                            "label": "Notifications_user$defer$NotificationsIcon_user",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Promotion",
                                "kind": "LinkedField",
                                "name": "activePromotion",
                                "plural": false,
                                "selections": (v28/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": (v41/*: any*/),
                                "concreteType": "ActivityFeedConnection",
                                "kind": "LinkedField",
                                "name": "activityFeed",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ActivityFeedEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ActivityFeedElement",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v42/*: any*/),
                                          (v43/*: any*/),
                                          (v17/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": "activityFeed(elementTypes:[\"PENDING_FEEDBACK\",\"TRADE_REWARD\",\"TRADE_REWARD_PRORATED\",\"TRADE_REWARD_PROGRAM\",\"AUTOMATED_OFFER\"],first:3)"
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ],
                "storageKey": null
              }
            ]
          },
          {
            "condition": "hasSessionCountryCode",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              {
                "alias": "regInfo",
                "args": null,
                "concreteType": "RegionalInfo",
                "kind": "LinkedField",
                "name": "regionalInfo",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "countryCode",
                    "storageKey": null
                  },
                  (v17/*: any*/)
                ],
                "storageKey": null
              }
            ]
          },
          {
            "condition": "fetchNav",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": [
                  (v45/*: any*/)
                ],
                "concreteType": "Navigation",
                "kind": "LinkedField",
                "name": "navigation",
                "plural": false,
                "selections": (v49/*: any*/),
                "storageKey": null
              }
            ]
          },
          {
            "condition": "fetchTradeNav",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "tradeNavigation",
                "args": [
                  (v45/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "userType",
                    "value": "TRADE"
                  }
                ],
                "concreteType": "Navigation",
                "kind": "LinkedField",
                "name": "navigation",
                "plural": false,
                "selections": (v49/*: any*/),
                "storageKey": null
              }
            ]
          },
          {
            "condition": "hasTradeUserId",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "if": null,
                "kind": "Defer",
                "label": "Contact1stdibsLink_viewer$defer$TradeRepCircle_viewer",
                "selections": [
                  {
                    "condition": "hasUserId",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": "tradeRep",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "relationshipType",
                            "value": "TRADE"
                          },
                          (v19/*: any*/)
                        ],
                        "concreteType": "UserRelationship",
                        "kind": "LinkedField",
                        "name": "userRelationships",
                        "plural": true,
                        "selections": [
                          {
                            "alias": "userDataB",
                            "args": null,
                            "concreteType": "RepData",
                            "kind": "LinkedField",
                            "name": "userDataBRep",
                            "plural": true,
                            "selections": [
                              (v37/*: any*/),
                              (v30/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "photoUrl",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v17/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "condition": "fetchRegionalInfo",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "countryCode",
                    "variableName": "userCountryCode"
                  },
                  (v21/*: any*/),
                  (v50/*: any*/)
                ],
                "concreteType": "RegionalInfo",
                "kind": "LinkedField",
                "name": "regionalInfo",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": [
                      (v50/*: any*/)
                    ],
                    "concreteType": "IncomeLevel",
                    "kind": "LinkedField",
                    "name": "incomeLevel",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "incomeBracket",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "incomePercentile",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v24/*: any*/),
                  (v17/*: any*/)
                ],
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "ferrum/306.0.0-2021-03-11T04:05:43.156Z/headerRootQuery",
    "metadata": {},
    "name": "headerRootQuery",
    "operationKind": "query",
    "text": null
  }
};
})();
(node as any).hash = 'b8bdc329d7fe7f33e22f6c84af05cc76';
export default node;
